export default "__VITE_ASSET__Co$DyaQ8__"